"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ckeditor_module_1 = require("./src/ckeditor.module");
exports.CKEditorModule = ckeditor_module_1.CKEditorModule;
var ckeditor_component_1 = require("./src/ckeditor.component");
exports.CKEditorComponent = ckeditor_component_1.CKEditorComponent;
var ckbutton_directive_1 = require("./src/ckbutton.directive");
exports.CKButtonDirective = ckbutton_directive_1.CKButtonDirective;
var ckgroup_directive_1 = require("./src/ckgroup.directive");
exports.CKGroupDirective = ckgroup_directive_1.CKGroupDirective;
//# sourceMappingURL=ng2-ckeditor.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-ckeditor/lib/ng2-ckeditor.js
// module id = 1075
// module chunks = 0